export var LayerKind;
(function (LayerKind) {
    LayerKind[LayerKind["MAIN"] = 0] = "MAIN";
    LayerKind[LayerKind["FACADE"] = 1] = "FACADE";
    LayerKind[LayerKind["COMPONENT"] = 2] = "COMPONENT";
})(LayerKind || (LayerKind = {}));
export var DesignSchemeSetType;
(function (DesignSchemeSetType) {
    DesignSchemeSetType[DesignSchemeSetType["FULL_SITE"] = 0] = "FULL_SITE";
    DesignSchemeSetType[DesignSchemeSetType["HAND_DRAWN"] = 1] = "HAND_DRAWN";
    DesignSchemeSetType[DesignSchemeSetType["DATA_BASED"] = 2] = "DATA_BASED";
})(DesignSchemeSetType || (DesignSchemeSetType = {}));
export var SchemeKey;
(function (SchemeKey) {
    SchemeKey["FLOOR_BASED"] = "FloorBased";
    SchemeKey["CONVEX_HULL"] = "ConvexHull";
    SchemeKey["ORIENTED_VOLUME"] = "OrientedVolume";
    SchemeKey["BOX"] = "Box";
})(SchemeKey || (SchemeKey = {}));
export var FacadeType;
(function (FacadeType) {
    FacadeType[FacadeType["TRANSPARENT"] = 0] = "TRANSPARENT";
    FacadeType[FacadeType["OPAQUE"] = 1] = "OPAQUE";
    FacadeType[FacadeType["TRANSPARENT_MAIN_DIRECTION"] = 2] = "TRANSPARENT_MAIN_DIRECTION";
    FacadeType[FacadeType["FACADE_WITH_OPENINGS"] = 3] = "FACADE_WITH_OPENINGS";
    FacadeType[FacadeType["HORIZONTALLY_ORIENTED"] = 4] = "HORIZONTALLY_ORIENTED";
    FacadeType[FacadeType["VERTICALLY_ORIENTED"] = 5] = "VERTICALLY_ORIENTED";
})(FacadeType || (FacadeType = {}));
export var FacadeComponentType;
(function (FacadeComponentType) {
    FacadeComponentType[FacadeComponentType["NOTHING"] = 0] = "NOTHING";
    FacadeComponentType[FacadeComponentType["PV_PANELS"] = 1] = "PV_PANELS";
    FacadeComponentType[FacadeComponentType["SHADING"] = 2] = "SHADING";
    FacadeComponentType[FacadeComponentType["BALCONIES"] = 3] = "BALCONIES";
    FacadeComponentType[FacadeComponentType["GREEN"] = 4] = "GREEN";
})(FacadeComponentType || (FacadeComponentType = {}));
export var FacadeDirectionMode;
(function (FacadeDirectionMode) {
    FacadeDirectionMode[FacadeDirectionMode["VOLUME_AVERAGE"] = 0] = "VOLUME_AVERAGE";
    FacadeDirectionMode[FacadeDirectionMode["FLOOR_AVERAGE"] = 1] = "FLOOR_AVERAGE";
    FacadeDirectionMode[FacadeDirectionMode["FACADE_AVERAGE"] = 2] = "FACADE_AVERAGE";
})(FacadeDirectionMode || (FacadeDirectionMode = {}));
export var VerticalFacadeCoverageMode;
(function (VerticalFacadeCoverageMode) {
    VerticalFacadeCoverageMode[VerticalFacadeCoverageMode["FACING"] = 0] = "FACING";
    VerticalFacadeCoverageMode[VerticalFacadeCoverageMode["FACING_AND_ADJACENT"] = 1] = "FACING_AND_ADJACENT";
    VerticalFacadeCoverageMode[VerticalFacadeCoverageMode["ALL"] = 2] = "ALL";
})(VerticalFacadeCoverageMode || (VerticalFacadeCoverageMode = {}));
export var ShadingAutomaticRectangleReference;
(function (ShadingAutomaticRectangleReference) {
    ShadingAutomaticRectangleReference[ShadingAutomaticRectangleReference["LONGER"] = 0] = "LONGER";
    ShadingAutomaticRectangleReference[ShadingAutomaticRectangleReference["SHORTER"] = 1] = "SHORTER";
})(ShadingAutomaticRectangleReference || (ShadingAutomaticRectangleReference = {}));
export var BorderMode;
(function (BorderMode) {
    BorderMode[BorderMode["SINGLE"] = 0] = "SINGLE";
    BorderMode[BorderMode["DUAL"] = 1] = "DUAL";
})(BorderMode || (BorderMode = {}));
export var BorderSource;
(function (BorderSource) {
    BorderSource[BorderSource["MAIN_LAYER"] = 0] = "MAIN_LAYER";
    BorderSource[BorderSource["FOOTPRINT"] = 1] = "FOOTPRINT";
    BorderSource[BorderSource["BOX"] = 2] = "BOX";
    BorderSource[BorderSource["BUILDABLE_BORDER"] = 3] = "BUILDABLE_BORDER";
    BorderSource[BorderSource["PROJECT_SKETCH"] = 4] = "PROJECT_SKETCH";
})(BorderSource || (BorderSource = {}));
